"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _InputBase = _interopRequireDefault(require("../InputBase"));
var _tss = require("../styles/tss");
const _excluded = ["classes", "fullWidth", "inputComponent", "type"];
const useStyles = (0, _tss.makeTssStyles)({
  name: 'DsFilledInput',
  uniqId: 'IyE0eY'
})((theme, _params, classes) => {
  const inputStyle = theme.busbud.colors.component.textfield;
  return {
    /* Styles applied to the root element. */
    root: {
      backgroundColor: inputStyle.normal.background,
      [`&:not(.${classes.focused}):not(.${classes.error}):hover`]: {
        backgroundColor: inputStyle.hover.background
      }
    },
    filled: {},
    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {
      backgroundColor: inputStyle.focused.background
    },
    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},
    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: theme.busbud.spacing(1.5)
    },
    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: theme.busbud.spacing(1.5)
    },
    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {
      backgroundColor: inputStyle.error.background,
      [`&.${classes.focused}`]: {
        backgroundColor: inputStyle.focused.background
      }
    },
    /* Styles applied to the `input` element. */
    input: {},
    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },
    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
});
/**
 * **❗️ DEPRECATED**: Use the new `Input` component from `@busbud/horizon` - [Storybook](https://main--66e336a480b3d19fa782310f.chromatic.com/?path=/docs/forms-input):
 *
 * ```tsx
 * import { Input } from "@busbud/horizon";
 * ```
 *
 * [Storybook](https://busbud.github.io/design-system/?path=/docs/components-inputs-textfield--page)
 *
 * @deprecated
 */
const FilledInput = /*#__PURE__*/_react.default.forwardRef(function FilledInput(props, ref) {
  const {
      classes: classesOverrides,
      fullWidth = false,
      inputComponent,
      type = 'text'
    } = props,
    other = (0, _objectWithoutProperties2.default)(props, _excluded);
  const {
    classes
  } = useStyles(undefined, {
    props: {
      classes: classesOverrides
    }
  });
  return /*#__PURE__*/_react.default.createElement(_InputBase.default, (0, _extends2.default)({
    classes: classes,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    ref: ref,
    type: type
  }, other));
});

// @ts-ignore
FilledInput.dsName = 'Input';
var _default = exports.default = FilledInput;